const prefix = 'fasr';
const iconName = 'line-height';
const width = 576;
const height = 512;
const aliases = [];
const unicode = 'f871';
const svgPathData = 'M95.6 33.7l17 16.1 64 60.8 17.4 16.5-33.1 34.8-17.4-16.5L120 123.1V386.9L139.8 367l17-17L190.7 384l-17 17L113 461.8l-17 17-17-17L18.2 401l-17-17 33.9-33.9 17 17L72 386.9V125.1L52.2 145l-17 17L1.3 128l17-17L79 50.2 95.6 33.7zM248 72H552h24v48H552 248 224V72h24zm0 160H552h24v48H552 248 224V232h24zM224 392h24H552h24v48H552 248 224V392z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
